import * as React from 'react';
import { useState, useContext } from 'react';
import { Grid, Fab, Dialog, Zoom, useTheme } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import AddIcon from '@material-ui/icons/Add';
import { useTranslation } from 'react-i18next';

import ProductCard from './ProductCard';
import { ProductContext } from '../store/productContext';
import ProductForm from './ProductForm';

const useStyles = makeStyles((theme: Theme) => ({
  fab: {
    position: 'fixed',
    right: 20,
    bottom: 20,
  },
  lastCard: {
    marginBottom: theme.spacing(10),
  },
}));

type Props = {
  products: Product[];
  loading: boolean;
};

const ProductListMobile: React.FC<Props> = ({ products, loading }: Props) => {
  const classes = useStyles();
  const [adding, setAdding] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();
  const { addProduct, getProducts, addProductLoading } = useContext(
    ProductContext
  );

  const handleAddSubmit = (data: ProductFormDto) => {
    addProduct(data, () => {
      setAdding(false);
      getProducts(true);
    });
  };

  const handleAddOpen = () => {
    setAdding(true);
  };

  const handleAddClose = () => {
    setAdding(false);
  };

  const transitionDuration = {
    enter: theme.transitions.duration.enteringScreen,
    exit: theme.transitions.duration.leavingScreen,
  };

  return (
    <Grid container spacing={3}>
      {products.map((p, index) => (
        <Grid
          key={p.id}
          item
          xs={12}
          className={index === products.length - 1 ? classes.lastCard : ''}
        >
          <ProductCard product={p} loading={loading} />
        </Grid>
      ))}
      <Zoom in timeout={transitionDuration} unmountOnExit>
        <Fab
          className={classes.fab}
          color="primary"
          aria-label="add"
          onClick={handleAddOpen}
        >
          <AddIcon />
        </Fab>
      </Zoom>
      <Dialog open={adding} onClose={handleAddClose}>
        <ProductForm
          onSubmit={handleAddSubmit}
          buttonText={t('common:add')}
          loading={addProductLoading}
          cancelButton
          onCancel={handleAddClose}
        />
      </Dialog>
    </Grid>
  );
};

export default ProductListMobile;
